export const AccountSystem = {
    ALYMENTE: '',
    SWAP: 'swap',
    ACG: 'acg'
}